import io from "socket.io-client";
import Cookies from "universal-cookie";
import { config, TOKEN_NAME } from "../config";

const cookies = new Cookies();

class WSService {
  constructor() {
    this.socket = null;
    this.connected = false;
    this.initializationInProgress = false;
  }

  initializeSocket = async () => {
    // If already initializing, don't start another initialization
    if (this.initializationInProgress) {
      // console.log("Socket initialization already in progress");
      return;
    }
    
    // If socket already exists and is connected, don't reinitialize
    if (this.socket && this.connected) {
      // console.log("Socket already initialized and connected");
      return;
    }

    const token = cookies.get(TOKEN_NAME);

    if (!token) {
      // console.error("No token available for socket connection");
      return;
    }

    try {
      this.initializationInProgress = true;
      
      // Cleanup any existing socket before creating a new one
      if (this.socket) {
        // console.log("Cleaning up existing socket before re-initializing");
        this.socket.disconnect();
        this.socket.removeAllListeners();
        this.socket = null;
      }

      // console.log("Initializing socket connection to:", config.chatapiurl);
      this.socket = io(config.chatapiurl, {
        extraHeaders: {
          Authorization: `${token}`,
        },
        reconnection: true,
        reconnectionAttempts: 5,
        reconnectionDelay: 1000,
      });
      
      this.socket.on("connect", () => {
        // console.log("=== Socket Connected ===");
        this.connected = true;
        this.initializationInProgress = false;
      });
      
      this.socket.on("disconnect", () => {
        // console.log("=== Socket Disconnected ===");
        this.connected = false;
      });
      
      this.socket.on("error", (error) => {
        // console.error("=== Socket Error ===", error);
        this.initializationInProgress = false;
      });
      
      this.socket.on("connect_error", (error) => {
        // console.error("=== Socket Connection Error ===", error);
        this.initializationInProgress = false;
      });
      
    } catch (error) {
      // console.error("Failed to initialize socket", error);
      this.initializationInProgress = false;
    }
  };

  disconnect() {
    if (this.socket) {
      // console.log("Disconnecting socket");
      this.socket.disconnect();
      this.connected = false;
      this.socket = null;
    }
  }

  emit(event, data = {}, cb) {
    if (!this.socket) {
      // console.error("Cannot emit - socket not initialized");
      return cb && cb({ success: false, error: "Socket not connected" });
    }
    this.socket.emit(event, data, cb);
  }
  
  on(event, cb) {
    if (!this.socket) {
      console.error("Cannot add listener - socket not initialized");
      return;
    }
    this.socket.on(event, cb);
  }
  
  removeListener(eventName, callback) {
    if (this.socket) {
      if (callback) {
        // Remove specific listener
        this.socket.off(eventName, callback);
      } else {
        // Remove all listeners for this event
        this.socket.removeListener(eventName);
      }
    }
  }

  isConnected() {
    return this.connected;
  }
}

const socketServices = new WSService();

export default socketServices;
